import { render, staticRenderFns } from "./BarHighShineAddon.vue?vue&type=template&id=35ea68e4"
import script from "./BarHighShineAddon.vue?vue&type=script&lang=js"
export * from "./BarHighShineAddon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports